import api from './api';

export const getCargoSettings = async () => {
    const response = await api.get('/cargoSettings');
    return response.data;
};

export const saveCargoSettings = async (data: any) => {
    const response = await api.post('/cargoSettings', data);
    return response.data;
};
export const syncPendingCargo = async () => {
    const response = await api.post('/cargo/sync-pending');
    return response.data;
};
export const createCargoForOrder = async (orderId: number) => {
    const response = await api.post(`/cargo/order/${orderId}/create`);
    return response.data;
};

export const checkCargoStatus = async (orderId: number) => {
    const response = await api.get(`/cargo/order/${orderId}/status`);
    return response.data;
};

export const cancelCargoForOrder = async (orderId: number) => {
    const response = await api.post(`/cargo/order/${orderId}/cancel`);
    return response.data;
};
